import { render, staticRenderFns } from "./aiNav.vue?vue&type=template&id=013d9023&scoped=true&"
import script from "./aiNav.vue?vue&type=script&lang=js&"
export * from "./aiNav.vue?vue&type=script&lang=js&"
import style0 from "./aiNav.vue?vue&type=style&index=0&id=013d9023&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013d9023",
  null
  
)

export default component.exports